import { Component, HostBinding, OnDestroy, OnInit, ChangeDetectorRef, AfterViewInit  } from '@angular/core';
import { CmsService } from '../../core/services/cms.service';
import { LogCategory, LoggerService, LogType, LogWidget } from '../../core/services/logger.service';
import { IWidgetComponent } from '../../shared/widget/i-widget-component';
import { Widget, ContentWidget } from '../../shared/widget/widget';
import { TagManagerService } from '../../core/services/tag-manager.service';
import { LoadingWrapper } from '../../shared/loadingwrapper'
import { ProfileService } from '../../core/services/profile.service';

@Component({
    selector: 'app-cms',
    templateUrl: './cms.component.html',
    styleUrls: ['./cms.component.scss'],
    standalone: false
})
export class CmsComponent implements OnInit, OnDestroy, AfterViewInit,  IWidgetComponent {
    public data: ContentWidget;
    cmsContent;

    @HostBinding('class')
    get size(): string {
        var widgetSize = 'col-md-' + this.data.Size.toString();

        switch (this.data.Size) {
            case 4: {
                widgetSize += ' widget-small';
                break;
            }
            case 6: {
                widgetSize += ' widget-medium';
                break;
            }
            case 12: {
                widgetSize += ' widget-large';
                break;
            }
        }

        return widgetSize;
    }

    constructor(
        public cms: CmsService,
        private profileService: ProfileService,
        private gtm: TagManagerService,
        private logger: LoggerService,
        private changeDetector: ChangeDetectorRef
    ) {
        this.log("constructor", null, LogCategory.Constructor);
    }
    private log(method: string = null, message = null, category: LogCategory = LogCategory.Default): void {
        method = (method) ? '.' + method + '()' : '';
        message = (message) ? message.toString() : '';
        this.logger.try(this.constructor.name + method + ': ' + message, LogType.Widget, LogWidget.Forms, category);
    }

    ngOnInit() {
        this.log("ngOnInit", null, LogCategory.Init);
        this.cms.currentContentType$.next(this.data.contentType);
        this.cmsContent = new LoadingWrapper(this.cms.getContentByType$);
    }

    ngOnDestroy() {
        this.log("ngOnDestroy", "", LogCategory.Destroy);
    }

    ngAfterViewInit() {
        // See https://blog.angularindepth.com/everything-you-need-to-know-about-the-expressionchangedafterithasbeencheckederror-error-e3fd9ce7dbb4
        // Added after error handling template added to component.
        this.changeDetector.detectChanges();
    }

    public get title(): string {
        return this.profileService.labelLookup[this.data.meta.Name];
    }

    public hasHtmlContent(contents) {
        return contents.some(c => c.Content != '');        
    }

    public linkClicked(item) {        
        this.gtm.gaLinkClicked(this.title, item.Title);
    }
}
